import { Section } from "../components/sections/TextSection";
import { borderProps, commonProps, fontProps } from "./commonPropInfo";

export const textBoxSectionConfig: Section = {
    row: 0,
    col: 0,
    name: 'TextBox',
    type: 'textbox',
    id: '1111',
    selected: false,
    height: 60,
    width: 60,
    rowCount: 10,
    colCount: 10,
    options: [{ label: 'Option 1', correctValue: "", showLabel: true }],
    textContent: "",
    x: 0,
    y: 0,
    value: [],
    isLocked: false,
    propInfo: [
        ...commonProps,
        ...borderProps,
        ...fontProps,
        {
            name: 'Textbox Height',
            binding: '$textbox-input.style.height',
            inputType: 'number',
            value: '20',
            label: 'height'
        },
        {
            name: "Textbox Font Color",
            inputType: 'color',
            binding: '$textbox-input.style.color',
            value: '',
            label: 'color',
        },
        {
            name: "Textbox background",
            inputType: 'color',
            binding: '$textbox-input.style.background',
            value: '#ffffff',
            label: 'Background',
        },
        {
            name: "Textbox Border Color",
            inputType: 'color',
            binding: '$textbox-input.style.borderColor',
            value: 'black',
            label: 'Border Color',
        },
        {
            name: 'Textbox Border',
            binding: '$textbox-input.style.border-width',
            inputType: 'number',
            value: '1',
            label: 'height'
        },
        {
            name: 'gap',
            binding: 'style.gap',
            inputType: 'number',
            value: '10px',
            label: 'Gap',
        },
        {
            name: "TextBoxes",
            inputType: 'multiOptionTextBox',
            binding: 'options',
            options: [
                { label: 'Option 1', correctValue: '', showLabel: false },
            ],
            value: [],
            label: 'Options',
        }
    ]
};
